import clsx from 'clsx';
import Image, { ImageProps } from 'next/image';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface EmployeeHeaderProps {
  className?: string;
  image: ImageProps['src'];
  imageClassName?: string;
  name: string;
  nameClassName?: string;
  subtitle: string;
}

const EmployeeHeader: React.FC<EmployeeHeaderProps> = ({ className, image, imageClassName, name, nameClassName, subtitle }) => (
  <div className={twMerge(clsx('align-center text-default flex min-h-[5rem] gap-4 text-sm font-normal', className))}>
    {image && (
      <Image
        alt=''
        className={twMerge(clsx('relative h-20 w-20 shrink-0 overflow-hidden rounded-full object-cover sm:h-28 sm:w-28', imageClassName))}
        height={112}
        priority
        src={image}
        width={112}
      />
    )}
    <div className='flex min-h-20 grow flex-col justify-center'>
      <p className={nameClassName}>{name}</p>
      <span>{subtitle}</span>
    </div>
  </div>
);

export default EmployeeHeader;
